"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_number_format_1 = __importDefault(require("react-number-format"));
/**
 * This component does not need to be displayed in Storybook, its just used by other components (NumberField)
 */
exports.default = react_1.default.forwardRef((props, ref) => {
    const { onChange } = props, others = __rest(props, ["onChange"]);
    return (react_1.default.createElement(react_number_format_1.default, Object.assign({ getInputRef: ref, onValueChange: (values) => {
            onChange({
                target: {
                    name: props.name,
                    value: values.floatValue,
                },
            });
        }, maxLength: props.maxLength || 8, decimalScale: props.decimalScale || 0, decimalSeparator: ",", thousandSeparator: " " }, others)));
});
